import type { TOC } from '@ember/component/template-only';

import MobileGoalsListComponent from 'webapp/components/mobile/goals-list';

const MobileGoalsRouteTemplate: TOC<object> = <template><MobileGoalsListComponent /></template>;

export default MobileGoalsRouteTemplate;
